// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgActionCreatorToken = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm1.968-7.667h1.782a3.147 3.147 0 0 0-.39-1.202c-.201-.35-.462-.645-.782-.886a3.486 3.486 0 0 0-1.103-.555A4.551 4.551 0 0 0 8.132 4c-.732 0-1.391.157-1.978.471a3.45 3.45 0 0 0-1.391 1.362C4.42 6.428 4.25 7.15 4.25 8c0 .847.168 1.568.505 2.164.339.595.8 1.05 1.383 1.364.586.315 1.25.472 1.994.472.535 0 1.014-.075 1.437-.224a3.52 3.52 0 0 0 1.098-.616c.31-.261.555-.557.737-.886.185-.332.3-.677.346-1.034l-1.782-.008a1.55 1.55 0 0 1-.61.97 1.77 1.77 0 0 1-.542.254c-.2.059-.42.088-.655.088-.42 0-.791-.097-1.111-.29A1.931 1.931 0 0 1 6.3 9.4c-.176-.377-.265-.844-.265-1.399 0-.54.089-.999.265-1.376.176-.38.425-.67.745-.867.32-.2.696-.3 1.127-.3.239 0 .46.031.663.094.206.064.388.155.546.274.157.12.286.264.386.434.1.167.167.358.2.574Z"
      fill="#F4F6F8"
    />
  </svg>
))
SvgActionCreatorToken.displayName = 'SvgActionCreatorToken'
const Memo = memo(SvgActionCreatorToken)
export { Memo as SvgActionCreatorToken }
